export const EVENT = {
  LOGOUT: "logout",
};
